import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { Router } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgApexchartsModule } from "ng-apexcharts";
import { Location } from '@angular/common';
declare let $: any;


import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexFill,
  ApexLegend
} from "ng-apexcharts";
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';

export interface lineChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  stroke: ApexStroke;
  legend: ApexLegend;
  colors: string[];
}


@Component({
  selector: 'app-employees-salary-info',
  imports: [CommonModule, NgApexchartsModule, FormsModule],
  templateUrl: './employees-salary-info.component.html',
  styleUrl: './employees-salary-info.component.css',
})
export class EmployeesSalaryInfoComponent implements OnInit {
  public lineChartOptions!: lineChartOptions;
  currentYear: number = new Date().getFullYear();
  months: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  selectedYear: number | null = null;
  years: number[] = [];
  selectedMonth: number | null = null;

  @Output() monthSelected = new EventEmitter<{ year: number, month: number }>();

  newChartOptions: any = {
    chart: {},
    labels: [],
    colors: [],
    plotOptions: {},
    legend: {},
    dataLabels: {},
    stroke: {}
  };

  newChartData: any[] = [];
  departmentsPayroll = [
    { department: 'HR', total: 50000 },
    { department: 'Finance', total: 75000 },
    { department: 'IT', total: 100000 },
    { department: 'Web', total: 50000 },
    { department: 'Mobile', total: 75000 },
    { department: 'BD', total: 100000 }
  ];
  releasedsummaryPercentage: any;
  summaryTotaldeduction: any;
  summaryFinalsettlement: any;
  summaryTotalgross: any;
  summaryPendingTotal: any;
  summaryTotalReleased: any;
  currentMonth: number = new Date().getMonth() + 1; currentPage: any;
  lastPage: any;
  selectedUser: any;
  ;
  userList: any;
  selectedPayroll: any;
  showSkeleton = true; // true while data is loading
  graphSkeleton = true;
  summarySkeleton = true;
  departmentSkeleton = true;
  leave_modification_Date: any;
  user_Roles: any;
  payrollList: any;
  modalcurrentYear: number = new Date().getFullYear();
  prevYear() {
    this.modalcurrentYear--;
  }

  nextYear() {
    this.modalcurrentYear++;
  }

  selectMonth(monthIndex: number) {
    this.selectedMonth = monthIndex;
    this.monthSelected.emit({ year: this.currentYear, month: monthIndex + 1 });

  }
  filters = {
    name: '',      // first+last name search
    role_id: ''    // role filter
  };

  constructor(

    public payrollService: PayrollService,
    public router: Router,
    private settings: SettingservicesService,
    private location: Location


  ) {

  }
  ngOnInit(): void {

    this.showUserRole();
    this.getUserList(1);






  }









  getUserList(page = 1) {
    this.showSkeleton = true
    this.currentPage = page;
    const limit = 50
    this.payrollService.getuserDetailList(this.filters, page, limit).then((value) => {
      this.userList = value?.data?.data || [];
      this.currentPage = value?.data?.current_page || 1;
      this.lastPage = value?.data?.last_page || 1;

    }).finally(() => {
      this.showSkeleton = false;
      // hide spinner after API call finishes
    });

  }

  goToPage(page: number) {
    if (page < 1 || page > this.lastPage) return;
    this.getUserList(page);
  }

  nextPage() {
    if (this.currentPage < this.lastPage) {
      this.getUserList(this.currentPage + 1);
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.getUserList(this.currentPage - 1);
    }
  }


  goToAddPayroll() {
    this.router.navigate(
      ['/add-new-payroll'],
      {
        queryParams: {
          month: this.currentMonth,
          year: this.currentYear
        },
        state: { fromPayrollList: true }

      }
    );
  }






  showUserRole() {
    this.settings.getUSerRole().then((value) => {
      if (value.success == true) {
        this.user_Roles = value.data
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }

    })
  }





  openPreview(user: any) {
    this.router.navigate(['past-payroll'], {
      state: {
        user_id: user.id,
        from: 'employee-salary-info' 
      }
    });
  }


  payrolselectMonth(index: any) {
    const monthNumber = index + 1; // 0-based → 1-based

    // Close Bootstrap modal
    ($('#payrollModal') as any).modal('hide');

    const month_int = monthNumber; // example: 1 = Jan, 2 = Feb, etc.

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const month_char = monthNames[monthNumber - 1];

    this.payrollService.addParollEntery(monthNumber, month_char, this.modalcurrentYear).then((value) => {
      this.payrollList = value?.data;

    }).finally(() => {
      this.showSkeleton = false;
      // hide spinner after API call finishes
    });





    // Navigate with selected month
    this.router.navigate(
      ['/add-new-payroll'],
      {
        queryParams: {
          month: monthNumber,
          year: this.modalcurrentYear
        }
      }
    );
  }


  userPayrolselectMonth(index: number) {
    if (!this.selectedUser) return;

    this.selectedMonth = index;

    const monthInt = index + 1;
    const monthChar = this.months[index];
    const monthYear = this.currentYear;

    // close modal
    $('#userpayrollModal').modal('hide');

    // navigate
    this.router.navigate(['/manual-payroll'], {
      state: {
        user: this.selectedUser,
        monthInt: monthInt,
        monthChar: monthChar,
        monthYear: monthYear
      }
    });

  }


  editCase(data: any) {
    this.router.navigate(['/manual-payroll'], { state: { user: data } });
  }

  setSelectedUser(user: any) {
    this.selectedUser = user;
  }


  goBack() {

    this.router.navigate(['/payroll-summary']);
  }



  resetFilters() {
    this.filters = {
      name: '',
      role_id: ''
    };
    this.getUserList(1); // reload the list after reset
  }

}
